import { BlogCategory } from '../types/blog';

export const formatDate = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString('tr-TR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const formatDateEN = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const formatReadTime = (minutes: number, language: 'tr' | 'en'): string => {
  return language === 'tr' ? `${minutes} dakika okuma` : `${minutes} min read`;
};

export const formatCategory = (category: BlogCategory, language: 'tr' | 'en'): string => {
  const categoryMap: Record<BlogCategory, { tr: string; en: string }> = {
    [BlogCategory.DIGITAL_TRANSFORMATION]: { tr: 'Dijital Dönüşüm', en: 'Digital Transformation' },
    [BlogCategory.CLOUD_SOLUTIONS]: { tr: 'Bulut Çözümleri', en: 'Cloud Solutions' },
    [BlogCategory.ARTIFICIAL_INTELLIGENCE]: { tr: 'Yapay Zeka', en: 'Artificial Intelligence' },
    [BlogCategory.CYBERSECURITY]: { tr: 'Siber Güvenlik', en: 'Cybersecurity' },
    [BlogCategory.SOFTWARE_DEVELOPMENT]: { tr: 'Yazılım Geliştirme', en: 'Software Development' },
    [BlogCategory.IT_CONSULTING]: { tr: 'IT Danışmanlık', en: 'IT Consulting' },
  };
  return categoryMap[category][language];
};